import { ArrowUpRight, Check, MessageCircle, Flame } from "lucide-react";
import { motion } from "framer-motion";
import { waLink } from "@/lib/brand";
import { usePlans, POPULAR_PID } from "@/hooks/usePlans";
import { Reveal } from "./Motion";

const PlanCard = ({ p, idx }) => {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  const href = p.link || waLink(`Olá! Gostaria de solicitar um teste da Opção ${p.pid} (R$ ${p.price}). Pode me ajudar?`);
  const popular = p.pid === POPULAR_PID;
  const [reais, cents] = String(p.price).split(",");

  return (
    <Reveal delay={idx * 0.07} className="h-full">
      <motion.article
        id={`plano-${p.pid}`}
        data-testid={`plan-card-opcao-${p.pid}`}
        onMouseMove={onMove}
        whileHover={{ y: -6 }}
        transition={{ type: "spring", stiffness: 260, damping: 22 }}
        className={`plan-card relative flex h-full flex-col overflow-hidden rounded-[22px] border p-6 scroll-mt-28 ${popular ? "border-cyan-300/50 bg-gradient-to-b from-[#1d1650] to-[#0e1120]" : "border-white/10 bg-[#0e1120]"}`}
      >
        <div className="flex h-7 items-center justify-between gap-2">
          <p className="whitespace-nowrap text-xs font-semibold tracking-[0.2em] text-zinc-400">OPÇÃO {p.pid}</p>
          {popular && <span data-testid="plan-popular-badge" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-cyan-300/40 bg-cyan-300/10 px-2 py-0.5 text-[11px] font-semibold text-cyan-200"><Flame className="h-3 w-3" />Mais procurado</span>}
        </div>
        <h3 className="mt-3 min-h-[3.5rem] font-display text-lg font-bold leading-snug">{p.tag}</h3>
        <p data-testid={`plan-price-opcao-${p.pid}`} className="mt-2 font-display font-black leading-none">
          <span className="mr-1 align-top text-lg text-zinc-300">R$</span>
          <span className={`text-6xl ${popular ? "grad-text" : "text-white"}`}>{reais}</span>
          {cents && <span className="text-2xl text-zinc-200">,{cents}</span>}
        </p>
        <ul className="mt-6 space-y-2.5 border-t border-white/10 pt-5">
          {(p.chips || []).map((c) => <li key={c} className="flex items-start gap-2 text-sm text-zinc-200"><Check className="mt-0.5 h-4 w-4 shrink-0 text-cyan-300" />{c}</li>)}
        </ul>
        <div className="mt-auto pt-8">
        <a data-testid={`plan-cta-opcao-${p.pid}`} href={href} target="_blank" rel="noreferrer" className="group flex w-full items-center justify-center gap-2 rounded-full grad-bg py-4 text-base font-bold text-white shadow-[0_14px_40px_-12px_rgba(139,92,246,.8)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_18px_50px_-10px_rgba(34,211,238,.7)]">
          {p.link ? <>Contratar na loja <ArrowUpRight className="h-5 w-5 transition-transform group-hover:rotate-45" /></> : <><MessageCircle className="h-5 w-5" /> Solicitar teste</>}
        </a>
        </div>
      </motion.article>
    </Reveal>
  );
};

export const Plans = () => {
  const plans = usePlans();
  return (
  <section id="planos" data-testid="plans-section" className="relative mx-auto max-w-[1400px] px-5 sm:px-10 py-24 sm:py-32">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-12 sm:mb-16">
      <Reveal className="lg:col-span-8">
        <p className="text-xs tracking-[0.35em] text-cyan-300">05 SERVIDORES</p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02]">Escolha o servidor<br />e solicite <span className="grad-text">seu teste.</span></h2>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-4 lg:self-end">
        <p className="text-base text-zinc-300">Contrate pelo WhatsApp em poucos minutos.</p>
      </Reveal>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 auto-rows-fr">
      {plans.map((p, i) => <PlanCard key={p.pid} p={p} idx={i} />)}
    </div>
  </section>
  );
};
